<script setup lang="ts">
import { type IconProps, resolveIcon } from './huge-icon';
import { computed } from 'vue';
import { HugeiconsIcon } from '@hugeicons/vue';

const props = withDefaults(defineProps<IconProps>(), { size: 24 });
const resolvedIcon = computed(() => resolveIcon(props.icon));
</script>

<template>
  <component
    :is="resolvedIcon.component"
    v-if="resolvedIcon.kind === 'svg'"
    :width="props.size"
    :height="props.size"
    :class="{ 'animate-spin': props.spin }"
  />
  <HugeiconsIcon
    v-else
    :icon="resolvedIcon.icon"
    :size="props.size"
    :class="{ 'animate-spin': props.spin }"
  />
</template>
